import React, { useState, useRef } from 'react';
import t from 'prop-types';
import useStatePosicionEnRango from '../util/use-state-posicion-en-rango';
import useStateTamEnRango from '../util/use-state-tam-en-rango';
import useEscalable from '../util/use-escalable';
import useArrastrable from '../util/use-arrastrable';

function VentanaFlotante(props) {
  // const [ posicion, setPosicion] = useState({x: props.x, y: props.y})
  var _useStatePosicionEnRa = useStatePosicionEnRango(props.x, props.y, -80, 80, 0, 90),
      pos = _useStatePosicionEnRa[0],
      setPos = _useStatePosicionEnRa[1]; // const [ tam, setTam ] = useState({w: props.ancho, h: props.alto})


  var _useStateTamEnRango = useStateTamEnRango(props.ancho, props.alto, 10, 100, 10, 100),
      tam = _useStateTamEnRango[0],
      setTam = _useStateTamEnRango[1];

  var _useState = useState(props.ajusteInicial),
      ajuste = _useState[0],
      setAjuste = _useState[1];

  var _useState2 = useState(false),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var ventanaRef = useRef(null);
  var tiradorRef = useRef(null);

  var _useArrastrable = useArrastrable({
    elementRef: ventanaRef,
    tirador: '.arrastreVentana',
    onArrastrando: function onArrastrando(posicion) {
      return setPos(posicion);
    }
  }),
      arrastrando = _useArrastrable.arrastrando;

  var _useEscalable = useEscalable({
    elementRef: ventanaRef,
    tiradorRef: tiradorRef,
    onEscalando: function onEscalando(tam) {
      return setTam(tam);
    },
    onStop: function onStop() {
      var onResize = props.onResize;
      onResize && onResize(tam.w, tam.h);
    },
    onStart: function onStart(tam) {
      if (!props.escalable) {
        return;
      }

      setAjuste('fijo');
      setTam(tam);
    }
  }),
      escalando = _useEscalable.escalando;

  function handleAnimationEnd(e) {
    if (props.abierta) {
      setVisible(true);
      return;
    }

    setVisible(false);
  }

  function construirEstilo() {
    var abierta = props.abierta;
    var style = {
      left: pos.x + '%',
      top: pos.y + '%',
      width: tam.w + '%',
      height: tam.h + '%'
    };

    if (!abierta && !visible) {
      style.position = "absolute";
      style.top = "-9999px";
      style.left = "-9999px";
      return;
    }

    if (escalando) {
      style.cursor = 'nwse-resize';
    }

    if (arrastrando) {
      style.cursor = 'move';
    }

    if (ajuste === 'contenido') {
      style.maxWidth = '90%';
      style.maxHeight = '80%';
      style.width = props.ancho;
      style.height = props.alto;
    }

    return style;
  }

  var id = props.id,
      abierta = props.abierta,
      escalable = props.escalable,
      claseExtra = props.claseExtra;
  var style = construirEstilo();
  var clases = [props.clases, 'ventana', abierta ? 'abierta' : 'cerrada', 'flotante', claseExtra ? claseExtra : ''].join(' ');
  return React.createElement('div', {
    id: id,
    className: clases,
    style: style,
    ref: ventanaRef,
    onAnimationEnd: handleAnimationEnd
  }, props.children, escalable && React.createElement('div', {
    className: 'escalarVentana',
    style: {
      right: 0,
      bottom: 0
    },
    ref: tiradorRef
  }));
}

VentanaFlotante.propTypes = process.env.NODE_ENV !== "production" ? {
  clases: t.string,
  tieneAnimacion: t.bool.isRequired,
  escalable: t.bool.isRequired,
  flotante: t.bool.isRequired,
  x: t.number,
  // %
  y: t.number,
  // %
  ancho: t.number,
  // %
  alto: t.number,
  // %
  abierta: t.bool,
  onResize: t.func,
  id: t.string,
  children: t.any,
  ajusteInicial: t.string,
  claseExtra: t.string
} : {};
VentanaFlotante.defaultProps = {
  clases: '',
  tieneAnimacion: true,
  escalable: false,
  flotante: false,
  abierta: false,
  x: 5,
  // en porcentaje
  y: 10,
  // en porcentaje
  ancho: 100,
  // en porcentaje
  alto: 100,
  // en porcentaje
  ajusteInicial: 'fijo'
};
export default VentanaFlotante;